import React from 'react';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx } from '../LayoutContext';
import { CaseContextSidebar } from '../../CaseClient';

// Granular Task-surface widget — renders the right-hand "Case context"
// sidebar that today is hard-wired into WorkItemTab. Customers composing
// custom Task layouts can drop this widget into a split-pane container to
// get the same case summary alongside their step form.

function TaskCaseContext() {
  const { case: caseRow, callbacks } = useLayoutCtx();
  return (
    <CaseContextSidebar
      caseRow={caseRow}
      onOpenCase={callbacks?.onOpenCase}
    />
  );
}

registerWidget({
  type: 'task.case_context',
  categories: ['task'],
  palette_label: 'Case context sidebar',
  description: 'Read-only case summary: number, title, status / priority badges, custom fields. Includes "Open full case" link.',
  Component: TaskCaseContext,
  configSchema: null,
  publishes: ['xv.OpenCase'],
  subscribes: ['xv.RefreshContext'],
  group: 'Task',
});
